import React from 'react'
import { Table, TableHead, TableCell, TableRow, TableBody, makeStyles, Grid, IconButton, Tooltip } from '@material-ui/core';
import { FormattedHTMLMessage } from 'react-intl';
import { CalculationOutputData, ProductData, ClampexTypeAttributes, ProductInputDataURL } from '../../redux/product/productTypes';
import { LanguageState, ApplicationState } from '../../redux/state';
import { LanguageCode } from '../../types/language';
import { FileType, DownloadCADFile } from '../../service/CADDrawingDownloader';
import { useSnackbar, VariantType } from 'notistack';
import { useIntl } from 'react-intl';
import OpenKTRShop from '../../service/OpenKTRShop';
import { Icon } from '@ktr/ktr-materialui-react';
import { useSelector } from 'react-redux';
import GetPicturePath from '../../service/GetPicturePath';
import { ClampexType } from '../../types/types';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import * as Analytics from '../../service/Analytics';

interface Props {
    className?: string,
    calculationOutputData?: CalculationOutputData,
    productData?: ProductData,
    language: LanguageState,
    clampexTypeAttributes: ClampexTypeAttributes,
    clampexType: ClampexType
    getPDFFile(): any
}

const useStyle = makeStyles({
    logo: {
        height: "auto",
        width: "190px"
    },
    button: {
        padding: "5px"
    },
    tableGrid: {
        //marginBottom: "10px"
    },
    icon: {
        height: "22px",
        width: "auto"
    },
    gridLeft: {
        textAlign: "right",
        paddingRight: "10px"
    },
    gridRight: {
        paddingLeft: "10px",
        textAlign: "left",
        borderLeft: "2px solid",
        borderColor: "orange"
    }

});


export default function ProductTable(props: Props) {
    const { enqueueSnackbar } = useSnackbar();
    const { formatMessage: f } = useIntl();
    const matches = useMediaQuery('(min-width:875px)');

    const appState = useSelector<ApplicationState, ApplicationState>(state => state);
    console.log("URL", window.location.host);
    
    //@ts-ignore
    // eslint-disable-next-line
    const values: ProductInputDataURL = {
        c_value: appState.product.productInputData.c_value,
        hid: appState.product.productInputData.hubInnerDiameter_D,
        hod: appState.product.productInputData.hubOuterDiameter,
        torque: appState.product.productInputData.torque,
        af: appState.product.productInputData.axialForce,
        rs: appState.product.productInputData.rotationSpeed,
        yss: appState.product.productInputData.yieldStrengthShaft,
        sd: appState.product.productInputData.shaftDiameter_d,
        sid: appState.product.productInputData.shaftInnerDiameter_diw,
        ysh: appState.product.productInputData.yieldStrengthShaft,
        msh: appState.product.productInputData.materialDensityHub,
        spf: appState.product.productInputData.screwPreloadForce,
        hw: appState.product.productInputData.hubWidth,
        sbtop: appState.product.productInputData.screwBoltingTorqueOverwritePercentage,
        sbt: appState.product.productInputData.screwBoltingTorque_Ts
    }


    //@ts-ignore
    //const parameter: string = new URLSearchParams(values).toString();
    
    /*let completeURL = "http://" +
        window.location.host +
        "/#/" +
        appState.product.currentProduct.type +
        "?" + parameter;
    */

    

    //this function will be executed when a drawing was not found
    const onError = () => {
        const variant: VariantType = "error";
        enqueueSnackbar(f({ id: 'app.error.drawingnotfound', defaultMessage: 'Drawing not found.' }), { variant });
    }

    const openPDF = () => {
        props.getPDFFile();
    }

    const classes = useStyle();
    return (

        <Grid>
            {props.productData !== undefined && props.calculationOutputData !== undefined ?
                <Grid container style={{ textAlign: 'center' }} className={props.className}>
                    <Grid className={classes.tableGrid} item sm={9} xs={12}>
                        {matches ?
                            <Table size="small" aria-label="simple table">
                                <TableHead >
                                    <TableRow>
                                        <TableCell align="left"><FormattedHTMLMessage id="app.result.table.matnr" /></TableCell>
                                        <TableCell align="left"><FormattedHTMLMessage id="app.result.table.description" /></TableCell>
                                        <TableCell align="left"><FormattedHTMLMessage id="app.result.table.availability" /></TableCell>
                                        <TableCell align="left"><FormattedHTMLMessage id="app.result.table.price" /></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    <TableRow>
                                        <TableCell align="left">{props.productData.matNr} </TableCell>
                                        <TableCell align="left">
                                            { //check language. If german set the german description and if every other language set english description because we only have german and english in database
                                                props.language.currentLanguage.langcode === LanguageCode.DE ?
                                                    props.productData.descriptionExtendedDE : props.productData.descriptionExtendedEN}
                                        </TableCell>
                                        <TableCell align="left">{props.productData.inStock ? <FormattedHTMLMessage id="app.result.table.inStock" /> : <FormattedHTMLMessage id="app.result.table.notInStock" />}</TableCell>
                                        <TableCell align="left">{props.productData.price === undefined || props.productData.price === null ? "-" : props.productData.price + " €"} </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            :
                            <Grid style={{marginBottom: "10px"}} container>
                                <Grid className={classes.gridLeft} item xs={5}>
                                    <FormattedHTMLMessage id="app.result.table.matnr" />
                                </Grid>
                                <Grid className={classes.gridRight} item xs={7}>
                                    {props.productData.matNr}
                                </Grid>

                                <Grid className={classes.gridLeft} item xs={5}>
                                    <FormattedHTMLMessage id="app.result.table.description" />
                                </Grid>
                                <Grid className={classes.gridRight} item xs={7}>
                                    { //check language. If german set the german description and if every other language set english description because we only have german and english in database
                                        props.language.currentLanguage.langcode === LanguageCode.DE ?
                                            props.productData.descriptionExtendedDE : props.productData.descriptionExtendedEN}
                                </Grid>

                                <Grid className={classes.gridLeft} item xs={5}>
                                    <FormattedHTMLMessage id="app.result.table.availability" />
                                </Grid>
                                <Grid className={classes.gridRight} item xs={7}>
                                    {props.productData.inStock ? <FormattedHTMLMessage id="app.result.table.inStock" /> : <FormattedHTMLMessage id="app.result.table.notInStock" />}
                                </Grid>

                                <Grid className={classes.gridLeft} item xs={5}>
                                    <FormattedHTMLMessage id="app.result.table.price" />
                                </Grid>
                                <Grid className={classes.gridRight} item xs={7}>
                                    {props.productData.price === undefined || props.productData.price === null ? "-" : props.productData.price + " €"}
                                </Grid>
                            </Grid>



                        }
                    </Grid>
                    <Grid item sm={3} xs={12}>
                        <Grid item xs={12}>
                            <img alt="clampexlogo" className={classes.logo} src={GetPicturePath(props.clampexType).productPicture} />
                            {
                                //src={props.clampexType.image} />
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <Tooltip arrow title={f({ id: 'app.result.shop', defaultMessage: 'Shop' })}>
                                <IconButton onClick={(() => { OpenKTRShop([props.productData ? props.productData.matNr : ""]);Analytics.gaEvent("Click - Go to Shop") })} className={classes.button}>
                                    <Icon.Shop className={classes.icon} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip arrow title="CAD-File download">
                                <IconButton onClick={(() => { DownloadCADFile(FileType.STEP, props.productData ? props.productData.matNr : "", onError); Analytics.gaEvent("Click - Download CAD drawing") })} className={classes.button}>
                                    <Icon.Cad className={classes.icon} />
                                </IconButton>
                            </Tooltip>
                            <Tooltip arrow title={f({ id: 'app.result.contact.popover', defaultMessage: 'Send request' })}>
                                <a href={"mailto://mail@ktr.com?subject=" + f({ id: 'app.result.contact.subject' }) + "&body="
                                    + f({ id: 'app.result.contact' }) + "%0A%0A" +
                                    "MatNr: " + props.productData.matNr + "%0A"
                                    + f({ id: 'app.result.table.description' }) + " " + props.productData.descriptionExtendedDE + "%0A%0A"
                                    + f({ id: 'app.result.contact.1' }) + "%0A"
                                    + f({ id: 'app.result.contact.2' }) + "%0A"
                                    + f({ id: 'app.result.contact.3' }) + "%0A"
                                    + f({ id: 'app.result.contact.4' }) + "%0A"
                                   //HACK: Implement this 
                                    /* + completeURL.split('&').join('%26') */}
                                    rel="noopener noreferrer"
                                    onClick={() => {Analytics.gaEvent("Click - Contact KTR")}}>
                                    <IconButton className={classes.button} >
                                        <Icon.Forward className={classes.icon} />
                                    </IconButton>
                                </a>
                            </Tooltip>
                            <Tooltip arrow title={f({ id: 'app.result.assembly', defaultMessage: 'Assembly' })}>
                                <a href={props.language.currentLanguage.langcode === LanguageCode.DE ?
                                    props.clampexTypeAttributes.assemblyManualDE :
                                    props.clampexTypeAttributes.assemblyManualEN} onClick={() => {Analytics.gaEvent("Click - Manual Download")}} target="_blank" rel="noopener noreferrer">
                                    <IconButton className={classes.button} >
                                        <Icon.AssemblyManual className={classes.icon} />
                                    </IconButton>
                                </a>
                            </Tooltip>
                            <Tooltip arrow title={f({ id: 'app.result.pdf', defaultMessage: 'PDF' })}>

                                <IconButton onClick={(() => { 
                                    openPDF();
                                    Analytics.gaEvent("Click - generate PDF");
                                    })} className={classes.button}>
                                    <Icon.oTools className={classes.icon} />
                                </IconButton>

                            </Tooltip>

                         

                            <Tooltip arrow title={f({ id: 'app.result.catalogue', defaultMessage: 'Catalogue' })}>
                                <a href={props.language.currentLanguage.langcode === LanguageCode.DE ?
                                    props.clampexTypeAttributes.catalogueURLDE :
                                    props.clampexTypeAttributes.catalogueURLEN} onClick={() => {Analytics.gaEvent("Click - Catalogue on KTR website")}} target="_blank" rel="noopener noreferrer">
                                    <IconButton className={classes.button} >
                                        <Icon.Catalogue className={classes.icon} />
                                    </IconButton>
                                </a>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
                : ""}
        </Grid>
    )

}
